import { JsonSchemaValidator } from "@common/json-schema-validator";
import { LogoHeight, LogoUrl, LogoWidth } from "../../interface";
import { logoHeight, logoUrl, logoWidth } from "../../schema";

export class MixerLogoSetCmd {
  private static validation = JsonSchemaValidator.compile(
    MixerLogoSetCmd.validationSchema()
  );

  readonly value: MixerLogoSet;

  constructor(value: MixerLogoSet) {
    this.value = JsonSchemaValidator.assert(MixerLogoSetCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["logoUrl", "logoWidth", "logoHeight"],
      properties: {
        logoUrl,
        logoWidth,
        logoHeight
      },
      additionalProperties: false
    };
  }
}

interface MixerLogoSet {
  logoUrl: LogoUrl;
  logoWidth: LogoWidth;
  logoHeight: LogoHeight;
}
